/* tslint:disable */
/* eslint-disable */
/**
 * Brandside Backend API
 * REST API бэкенда Brandside. Авторизация — Bearer-токен Laravel Passport (заголовок Authorization: Bearer token). Успешные ответы оборачиваются в конверт success_response — status: true, data: ...; ошибки — common_error_response — status: false, errors._common: сообщение.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime'
import type { MapParams } from './MapParams'
import {
  MapParamsFromJSON,
  MapParamsFromJSONTyped,
  MapParamsToJSON,
} from './MapParams'

/**
 *
 * @export
 * @interface ContactsPageData
 */
export interface ContactsPageData {
  /**
   *
   * @type {string}
   * @memberof ContactsPageData
   */
  address: string
  /**
   *
   * @type {string}
   * @memberof ContactsPageData
   */
  telegram: string
  /**
   *
   * @type {string}
   * @memberof ContactsPageData
   */
  phone: string
  /**
   *
   * @type {string}
   * @memberof ContactsPageData
   */
  whatsapp: string
  /**
   *
   * @type {string}
   * @memberof ContactsPageData
   */
  workTime: string
  /**
   *
   * @type {string}
   * @memberof ContactsPageData
   */
  max: string
  /**
   *
   * @type {MapParams}
   * @memberof ContactsPageData
   */
  mapParams: MapParams
}

/**
 * Check if a given object implements the ContactsPageData interface.
 */
export function instanceOfContactsPageData(
  value: object
): value is ContactsPageData {
  if (!('address' in value) || value['address'] === undefined) return false
  if (!('telegram' in value) || value['telegram'] === undefined) return false
  if (!('phone' in value) || value['phone'] === undefined) return false
  if (!('whatsapp' in value) || value['whatsapp'] === undefined) return false
  if (!('workTime' in value) || value['workTime'] === undefined) return false
  if (!('max' in value) || value['max'] === undefined) return false
  if (!('mapParams' in value) || value['mapParams'] === undefined) return false
  return true
}

export function ContactsPageDataFromJSON(json: any): ContactsPageData {
  return ContactsPageDataFromJSONTyped(json, false)
}

export function ContactsPageDataFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): ContactsPageData {
  if (json == null) {
    return json
  }
  return {
    address: json['address'],
    telegram: json['telegram'],
    phone: json['phone'],
    whatsapp: json['whatsapp'],
    workTime: json['workTime'],
    max: json['max'],
    mapParams: MapParamsFromJSON(json['mapParams']),
  }
}

export function ContactsPageDataToJSON(value?: ContactsPageData | null): any {
  if (value == null) {
    return value
  }
  return {
    address: value['address'],
    telegram: value['telegram'],
    phone: value['phone'],
    whatsapp: value['whatsapp'],
    workTime: value['workTime'],
    max: value['max'],
    mapParams: MapParamsToJSON(value['mapParams']),
  }
}
